import { css, SerializedStyles } from '@emotion/react';
import { colors } from '@airwallex/global';

const { ultraViolet, greyOnGreyText, white, greys, inputBackground, softGrey, red } = colors;

export const labelContainerCss = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const labelCss = css`
  font-size: 14px;
  line-height: 24px;
  color: ${greys[100]};
  margin-bottom: 4px;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
`;

export const inputContainerCss = css`
  position: relative;
`;

export const prefixCss = css`
  position: absolute;
  top: 8px;
  left: 12px;
  line-height: 24px;
`;

export const suffixCss = css`
  position: absolute;
  top: 8px;
  right: 12px;
  line-height: 24px;
`;
export const errorCss = css`
  font-size: 12px;
  color: ${red};
`;

export const hintCss = css`
  color: ${greys[60]};
  margin: 4px 0px;
`;

export const inputCss = (
  touched: boolean,
  error?: string,
  prefix?: React.ReactNode,
  suffix?: React.ReactNode
): SerializedStyles => css`
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  background: ${inputBackground};
  border: 1px solid ${touched && error ? red : softGrey};
  border-radius: 4px;
  font-size: 14px;
  line-height: 24px;
  height: 40px;
  color: ${colors.greys[100]};
  padding-left: ${prefix ? 48 : 16}px;
  padding-right: ${suffix ? 48 : 16}px;
  -webkit-appearance: none;
  box-shadow: none !important;
  font-family: inherit;
  -webkit-tap-highlight-color: transparent !important;
  &::placeholder {
    color: ${colors.greys[50]};
  }
  &:hover {
    background-color: ${white};
    border: 1px solid ${greyOnGreyText};
  }
  &:focus {
    border: 2px solid ${ultraViolet};
    box-shadow: 0px 0px 0px 1px ${ultraViolet};
    padding-left: ${prefix ? 35 : 15}px;
    padding-right: ${suffix ? 35 : 15}px;
    background-color: ${inputBackground};
    -webkit-tap-highlight-color: transparent !important;
    outline: none !important;
  }
`;
